// stores/PaymentStore.ts
import { makeAutoObservable, observable } from "mobx";
import api, {
  PostPaymePaymentParameters,
  PostPaymePaymentRes,
} from "../api";
import { createRequestStatus, handleRequest, } from "../toll/toolRequestStatus";

class PaymentStore {
  createPaymePaymentStatus = createRequestStatus();
  createPaymePaymentSuccess?: boolean
  createPaymePaymentData?: PostPaymePaymentRes


  constructor () {
    makeAutoObservable(this);
  }

  resetCreatePaymePayment() {
    this.createPaymePaymentSuccess = false;
    this.createPaymePaymentData = undefined
  }


  createPaymePayment = async (params:PostPaymePaymentParameters) => {
    await handleRequest<PostPaymePaymentRes>(
      this.createPaymePaymentStatus,
      () => api.PostPaymePayment(params),
      (res) => {
        this.createPaymePaymentData = res
        this.createPaymePaymentSuccess = true;
      },
      "新增捐款失败"
    );
  };



}
const paymentStore = new PaymentStore();;

export default paymentStore
